import { StringCafsValue } from "../../../../../../api/types/cafs";
import { InputDefinition } from "../../../../../../api/types/inputs";

const pickNumber = (cv: StringCafsValue | undefined): number =>
  ((cv?.Base !== "" ? Number(cv?.Base) : undefined) ??
    Number(cv?.Current) ??
    0) as number;

export const cnRatioFn = (
  values: Record<keyof InputDefinition, StringCafsValue>,
): string => {
  const carbonContent = pickNumber(values.CarbonContent);
  const biomDMN = pickNumber(values.BiomDMN);

  if (biomDMN === 0) return "∞:1";

  const value = carbonContent / (biomDMN / 1000);
  return `${Math.round(value * 10) / 10}:1`;
};
